import styled from "styled-components";

const Label = styled.label`
    display: flex;   
    align-items: center;
    justify-content: center;

    color: #fff;
    border: 2px;
    padding: 5px 8px;
    margin: 2px;
    line-height: 1rem;
    cursor: pointer;
    -webkit-transition: 300ms;
    transition: 300ms;
    box-shadow: 1px 2px 2px 1px rgb(0 0 0 / 25%);
    padding: 6px 10px;
    height: 32px;
    min-width: 32px;
    background-color: var(--grey);
    border-radius: 50%;
`;

export default Label;
